import React, { Component, Fragment } from "react";
import { VouchersComponent } from "../../components/VouchersComponent";
import {CreateVoucherComponent} from "../../components/CreateVoucherComponent";
import { connect } from "react-redux";
import {getAllUsers} from "../../actions/users";
import {setAlert} from "../../actions/alerts";
import {
    getVouchers,
    getUnUsedVouchers,
    getUsedVouchers,
} from "../../actions/vouchers";
class Vouchers extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.props.getVouchers();
        this.props.getUnUsedVouchers();
        this.props.getUsedVouchers();
        this.props.getAllUsers();
    }

    render(){
        return (
            <Fragment>
                <div className="container">
                    <div className="row m-0 p-0">
                        <div className="col-md-12 m-0 p-0">
                            <div className="dashboard-header-wrapper">
                                <h3 className="dashboard-header-text">Dashboard</h3>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <CreateVoucherComponent users={this.props.users} setalert={this.props.setAlert}/>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <VouchersComponent vouchers={this.props.vouchers} title="All Vouchers" usersObject={this.props.usersObject}/>
                        </div>
                        <div className="col-md-12">
                            <VouchersComponent  title="Unused Vouchers"  vouchers={this.props.unUsedVouchers} usersObject={this.props.usersObject}/>
                        </div>
                        <div className="col-md-12">
                            <VouchersComponent vouchers={this.props.usedVouchers} title="Used Vouchers" usersObject={this.props.usersObject}/>
                        </div>

                    </div>



                </div>
            </Fragment>
        );
    }

}

const mapStateToProps = (state) => ({
    vouchers: state.vouchers.vouchers,
    usedVouchers: state.vouchers.usedVouchers,
    unUsedVouchers: state.vouchers.unUsedVouchers,
    users: state.users.users,
});

export default connect(mapStateToProps, { getVouchers, getUnUsedVouchers, getUsedVouchers, getAllUsers, setAlert})(
    Vouchers
);